import * as apiHelper from '../../utils/apiHelper';
import { handleResponse } from '../../utils/handle-response';

export function getSQLFiles(path, connectionString) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETSQLFILES);
    url += `?path=${path}`
    url += `&connectionString=${connectionString}`

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function executeSQLScripts(scripts, connectionString) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        }, body:
            JSON.stringify({
                sqlScripts: scripts,
                connectionString: connectionString
            })
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_EXECUTESQLSCRIPTS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}